import {createSlice} from '@reduxjs/toolkit';
import {loadEnabledFeatures} from './actions';
import {EnabledFeaturesState} from './types';

const initialState: EnabledFeaturesState = {
  enabledFeatures: [],
  enabledFeaturesLoadingStatus: 'NotLoaded',
  isInitialized: false,
};

const slice = createSlice({
  name: 'features',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadEnabledFeatures.pending, (state) => {
        state.enabledFeaturesLoadingStatus = 'Loading';
      })
      .addCase(loadEnabledFeatures.fulfilled, (state, action) => {
        state.enabledFeatures = action.payload;
        state.enabledFeaturesLoadingStatus = 'Loaded';
        state.isInitialized = true;
      })
      .addCase(loadEnabledFeatures.rejected, (state) => {
        state.enabledFeaturesLoadingStatus = 'Failed';
      });
  },
});

export const {reducer: featuresReducer} = slice;
